import React, { useEffect, useState } from 'react';
import 'katex/dist/katex.min.css';
import renderMathInElement from "katex/dist/contrib/auto-render.js";
import { useNavigate } from 'react-router-dom';
import './index.css';
import { flattenKatexUnderlines } from 'global/katexWrap';

type DigitalInstructionProps = {
    subject: string;
};

function DigitalACTDirection({ subject }: DigitalInstructionProps) {
    const [direction, setDirection] = useState('');

    const renderKatex = () => {
        const katex = document.getElementsByClassName('katex');
        for (let i = 0; i < katex.length; i++) {
            renderMathInElement(katex[i], {
                delimiters: [
                    {left: '$$', right: '$$', display: true},
                    {left: '$', right: '$', display: false},
                    {left: '\\(', right: '\\)', display: false},
                    {left: '\\[', right: '\\]', display: true}
                ],
                trust: true
            });

            katex[i].innerHTML = katex[i].innerHTML.replaceAll('&nbsp;', ' ');
        }

        const wrappingTexts = document.querySelectorAll<HTMLElement>('.katex-html .base');
        for (let i = 0; i < wrappingTexts.length; i++) {
            if (subject === 'Reading and Writing') {
                wrappingTexts[i].classList.add('wrap');
            }
            else {
                wrappingTexts[i].classList.remove('wrap');
            }
        }

        flattenKatexUnderlines(document);

        const math = document.querySelectorAll('.katex-mathml');
        for (let i = 0; i < math.length; i++) {
            math[i].remove();
        }
    }

    useEffect(()=>{
        if (subject==='ACT English'){
            setDirection(`$\\textbf{English Test Directions}$$\\\\\\,\\\\$
                The next screen in this section contains instructions about the English test. That screen is not part of the scored questions. You can return to the instructions at any time by selecting the $\\textbf{Index}$ icon and then selecting $\\textbf{Instructions}$.$\\\\\\,\\\\$
                You may use scratch paper on this test. You will hand that to the room supervisor at the end of testing.$\\\\\\,\\\\$
                The timer will start when you select $\\textbf{Next}$ to begin the English test.`)
        } else if (subject==='ACT Mathematics'){
            setDirection(`$\\textbf{Mathematics Test Directions}$$\\\\\\,\\\\$ 
                The next screen in this section contains instructions about the Mathematics test. That screen is not part of the scored questions. You can return to the instructions at any time by selecting the $\\textbf{Index}$ icon and then selecting $\\textbf{Instructions}$.$\\\\\\,\\\\$ 
                You are permitted to use a calculator on this test, and you may get it out now. Some types of calculators are prohibited. For example, you may not use any version of the TI-89. You are responsible for knowing if your calculator is permitted. Testing staff will check your calculator periodically during the test. If you use a prohibited calculator, you will be dismissed, and your tests will not be scored.$\\\\\\,\\\\$ 
                You are responsible for making sure your calculator is working properly. You will not be provided with backup batteries or a replacement calculator. A calculator is provided on-screen as part of the test.$\\\\\\,\\\\$
                Do not share your calculator with another examinee. Do not connect your calculator in any way to the computer.$\\\\\\,\\\\$
                If you need to use your backup calculator, raise your hand and testing staff will check it. You may have only one calculator on your workstation or in operation at a time. If you did not bring a backup calculator and yours malfunctions, continue testing.$\\\\\\,\\\\$ 
                If your calculator has games or other functions, you may not use those functions during the test; you may use only the mathematics functions. Keep your calculator flat on your workstation.$\\\\\\,\\\\$ 
                You may use scratch paper on this test. You will hand that to the room supervisor at the end of testing.$\\\\\\,\\\\$ 
                The timer will start when you select $\\textbf{Next}$ to begin the Mathematics test.`)
        } else if (subject==='ACT Reading'){
            setDirection(`$\\textbf{Reading Test Directions}$$\\\\\\,\\\\$
                The next screen in this section contains instructions about the Reading test. That screen is not part of the scored questions. You can return to the instructions at any time by selecting the $\\textbf{Index}$ icon and then selecting $\\textbf{Instructions}$.$\\\\\\,\\\\$
                You may use scratch paper on this test. You will hand that to the room supervisor at the end of testing.$\\\\\\,\\\\$
                The timer will start when you select Next to begin the Reading test.`)
        } else if(subject==='ACT Science'){
            setDirection(`$\\textbf{Science Test Directions}$$\\\\\\,\\\\$
                The next screen in this section contains instructions about the Science test. That screen is not part of the scored questions. You can return to the instructions at any time by selecting the $\\textbf{Index}$ icon and then selecting $\\textbf{Instructions}$.$\\\\\\,\\\\$
                You may use scratch paper on this test. You will hand that to the room supervisor at the end of testing.$\\\\\\,\\\\$
                The timer will start when you select $\\textbf{Next}$ to begin the Science test.`)
        }
    }, []);

    useEffect(()=>{
        renderKatex();
    }, [direction])

    return (
        <div className='digitalACTInstruction'>
            <div className='digitalACTInstructionBox'>
                <span className='katex'>
                    {direction}
                </span>
            </div>
        </div>
    );
}

export default DigitalACTDirection;